export interface MtLandingBuyerProps {}
